import { ValueOf } from 'type-fest'

import { CheckboxNode } from './components/CheckboxNode'
import { CollapsibleNode } from './components/CollapsibleNode'
import { isCheckboxNode, isCollapsibleNode } from './utils'

import type { CreateListItemProps, Options } from './types'
import type { FieldValues } from 'react-hook-form'

export const createListItem = <T extends FieldValues>({
  disabled,
  field,
  filter,
  options,
  parentPath = '',
  recursionDeep,
}: CreateListItemProps<T>): (JSX.Element | null)[] =>
  Object.entries(options).map(
    ([key, value]: [key: string, value: ValueOf<Options>]): JSX.Element | null => {
      const path = parentPath ? `${parentPath}.${key}` : key

      if (isCheckboxNode(value)) {
        return (
          <CheckboxNode<T>
            currentValue={value}
            disabled={disabled}
            field={field}
            key={path}
            path={path}
          />
        )
      } else if (isCollapsibleNode(value)) {
        return (
          <CollapsibleNode<T>
            currentValue={value}
            disabled={disabled}
            field={field}
            filter={filter}
            key={path}
            onCreateListItem={createListItem}
            path={path}
            recursionDeep={recursionDeep}
          />
        )
      } else {
        return null
      }
    },
  )
